import Container from "./Container"
import empresa from "./empresa"
import contabilidad from "./contabilidad"
export default {
    empresa,
    contabilidad,
    Container
}